/** @jsxImportSource @emotion/react */

import { useQuery } from '@apollo/client'
import React, { useState } from 'react'
import { Loader } from 'components/Loader'
import { OrderDirection, ServiceCategoryTypeEnum, ServicePageTypeEnum } from '__generatedTypes__/globalTypes'
import { findAllPlatforms_findAllPlatforms_items as Platform } from '__generatedTypes__/findAllPlatforms'
import * as productPricingClasses from 'pagesNew/UpgradePage/ProductPricing/styles'
import { FIND_ALL_ADMISSION_SERVICES } from 'queries/admissionService'
import { findAllAdmissionService, findAllAdmissionServiceVariables } from '__generatedTypes__/findAllAdmissionService'
import TabsNavigation from 'components/TabsNavigation'
import * as classes from '../styles'
import { Form } from './Form'

const TABS: Array<{ id: ServiceCategoryTypeEnum; title: string }> = [
  {
    id: ServiceCategoryTypeEnum.CompleteApplication,
    title: 'Complete Application',
  },
  {
    id: ServiceCategoryTypeEnum.SecondaryApplication,
    title: 'Secondary Application',
  },
  {
    id: ServiceCategoryTypeEnum.InterviewPrep,
    title: 'Interview Prep',
  },
]

type Props = {
  platform: Omit<Platform, '__typename'>
  page: ServicePageTypeEnum
}

export const AdmissionServices = ({ page, platform }: Props) => {
  const [activeTab, setActiveTab] = useState(TABS[0])

  const { data, loading } = useQuery<findAllAdmissionService, findAllAdmissionServiceVariables>(
    FIND_ALL_ADMISSION_SERVICES,
    {
      variables: {
        query: {
          where: {
            platform: {
              id: platform.id,
            },
            page,
          },
          order: {
            createdAt: OrderDirection.DESC,
          },
        },
      },
    }
  )

  const renderForms = () =>
    data?.findAllAdmissionService?.items
      .filter(({ category }) => category === activeTab.id)
      .sort((a, b) => (a.price > b.price ? 1 : -1))
      .map((upgradePage) => <Form data={upgradePage} key={upgradePage.id} />)

  if (loading) {
    return <Loader />
  }

  return (
    <div>
      <TabsNavigation css={classes.innerTabs} tabs={TABS} value={activeTab} onChange={(tab) => setActiveTab(tab)} />
      <div css={productPricingClasses.container}>{renderForms()}</div>
    </div>
  )
}
